import { tabelaErroProcessamentoStyles } from './TabelaErroProcessamento.style'

export function tabelaErroProcessamentoIO() {
  return {
    styles: tabelaErroProcessamentoStyles
  }
}

export type TabelaErroProcessamentoIO = ReturnType<typeof tabelaErroProcessamentoIO>
